export default __webpack_public_path__ + "content/media/35.7bc3338d.jpg";